import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../assets/css/HomePage.css";
import { av1, av2, av3, av4 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ---------- SEO helpers ---------- */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    // порядок атрибутов: href -> hreflang
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Aviator = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

useEffect(() => {
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // Альтернативные URL
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // Главный тайтл и описание (EN → BN переводы уже заданы)
  const pageTitleEN = " HHBD Aviator — Fast Crash Game for Real BDT Wins";
  const pageDescEN =
    " Play HHBD Aviator — the fast-paced crash game for real BDT! Bet smart, cash out at the right time & enjoy instant payouts via bKash. Simple, fair & thrilling gameplay for Bangladeshi players who love high-stakes fun.";

  const pageTitleBN = " HHBD Aviator — রিয়েল BDT জয়ের জন্য দ্রুত ক্র্যাশ গেম";
  const pageDescBN =
    "HHBD Aviator খেলুন — আসল টাকায় দ্রুতগতির ক্র্যাশ গেম! স্মার্ট বাজি ধরুন, সঠিক সময়ে টাকা আউট করুন এবং বিকাশের মাধ্যমে তাৎক্ষণিক পেমেন্ট উপভোগ করুন। বাংলাদেশী খেলোয়াড়দের জন্য সহজ, ন্যায্য এবং রোমাঞ্চকর গেমপ্লে যারা উচ্চ-বাজির মজা পছন্দ করেন।";

  const pageKeywordsEN =
    "HHBD Aviator, crash game BD, high multiplier game, Aviator Bangladesh, cash out game, BDT crash betting";
  const pageKeywordsBN =
    "HHBD অ্যাভিয়েটর, ক্র্যাশ গেম বিডি, মাল্টিপ্লায়ার গেম, ক্যাশআউট গেম, বেটিং বিডি, দ্রুত উত্তোলন";

  const isBN = lang === "bn";

  // Тайтл используется в UPPERCASE во всех обычных тайтлах (document/OG/Twitter)
  const pageTitle = (isBN ? pageTitleBN : pageTitleEN).toUpperCase();
  const pageDesc = isBN ? pageDescBN : pageDescEN;            // description остается обычным регистром
  const pageKeywords = isBN ? pageKeywordsBN : pageKeywordsEN; // keywords остаются обычным регистром

  const ogImage = toAbsoluteUrl(av1);

  // Альты — не тайтлы, оставляем читабельными
  const twitterSite = "@HHBD_official";    // замените на реальный @
  const twitterCreator = "@HHBD_official"; // замените при необходимости
  const twitterImageAlt = isBN
    ? "HHBD Aviator - একটি উত্তেজনাপূর্ণ ক্র্যাশ গেম যেখানে নিখুঁত সময় বাংলাদেশি খেলোয়াড়দের জন্য প্রকৃত বাংলাদেশি ডলার জয়ের দিকে নিয়ে যায়।"
    : "HHBD Aviator – exciting crash game where perfect timing leads to real BDT wins for Bangladeshi players.";

  // <title> + базовые meta
  document.title = pageTitle;                 // ✅ UPPERCASE
  setMetaName("description", pageDesc);       // обычный регистр
  setMetaName("keywords", pageKeywords);      // обычный регистр

  // Canonical + hreflang
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // ------ Open Graph (тайтл в UPPERCASE) ------
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);          // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc);     // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? pageTitleBN : pageTitleEN); // alt — нормально читаемый текст
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // ------ Twitter (тайтл в UPPERCASE, добавить twitter:url) ------
  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);         // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);    // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);       // ✅ добавлено
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);
  setMetaName("twitter:label1", isBN ? "মোড" : "Mode");
  setMetaName("twitter:data1", isBN ? "লাইভ ক্র্যাশ গেম" : "Live crash game");
  setMetaName("twitter:label2", isBN ? "প্ল্যাটফর্ম" : "Platform");
  setMetaName("twitter:data2", "Android");


  
}, [lang, pathname]);


  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/aviator";

      // Page copy aligned with visible content
      const titleEN = " HHBD Aviator — Fast Crash Game for Real BDT Wins";
      const descEN =
        " Play HHBD Aviator — the fast-paced crash game for real BDT! Bet smart, cash out at the right time & enjoy instant payouts via bKash. Simple, fair & thrilling gameplay for Bangladeshi players who love high-stakes fun.";

      const titleBN = "HHBD Aviator — রিয়েল BDT জয়ের জন্য দ্রুত ক্র্যাশ গেম";
      const descBN =
        "HHBD Aviator খেলুন — আসল টাকায় দ্রুতগতির ক্র্যাশ গেম! স্মার্ট বাজি ধরুন, সঠিক সময়ে টাকা আউট করুন এবং বিকাশের মাধ্যমে তাৎক্ষণিক পেমেন্ট উপভোগ করুন। বাংলাদেশী খেলোয়াড়দের জন্য সহজ, ন্যায্য এবং রোমাঞ্চকর গেমপ্লে যারা উচ্চ-বাজির মজা পছন্দ করেন।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps = (isBN ? descBN : descEN);
      const inLang = isBN ? "bn" : "en";


      // Use the hero image as primary
      const ogImage =
        typeof av1 === "string"
          ? (/^https?:\/\//i.test(av1) ? av1 : `${origin}${av1.startsWith("/") ? "" : "/"}${av1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage (Aviator landing)
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": ogImage
        },

        // Organization (with description as requested)
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {av1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (official HHBD app)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD App",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": ogImage,
          
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
 <>
    <section className="zHHBD-aviatorhero">
      {/* background */}
      <div className="zHHBD-aviatorhero__bg">
        <div className="zHHBD-aviatorhero__overlay"></div>
        <div className="zHHBD-aviatorhero__flare zHHBD-aviatorhero__flare--1"></div>
        <div className="zHHBD-aviatorhero__flare zHHBD-aviatorhero__flare--2"></div>
      </div>

      {/* animated plane */}
      <div className="zHHBD-aviatorhero__plane"></div>

      <div className="zHHBD-aviatorhero__container">
        <div className="zHHBD-aviatorhero__content">
          <h1 className="zHHBD-aviatorhero__title">
            HHBD Aviator – Fly High & Cash Out Before the Crash
          </h1>
          <p className="zHHBD-aviatorhero__desc">
            Feel the surge of Aviator — the ultra-quick crash sensation adored throughout Bangladesh.
            Set your stake, watch the lucky aircraft soar, and collect returns as the multiplier scales up every second.
            The entire art is in the exit — secure your payout well before the plane blinks out and the round ends!
          </p>
          <div className="zHHBD-aviatorhero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-aviatorhero__btn zHHBD-aviatorhero__btn--main"
              title="Enter HHBD Aviator now — predefine clean exit targets to build steady, dependable cashouts in focused, disciplined sessions"
            >
              Start Your Flight Now
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-aviatorhero__btn zHHBD-aviatorhero__btn--ghost"
              title="Install the HHBD app to enjoy Aviator anywhere with fluid performance and uninterrupted play on mobile"
            >
              Get the App for Free
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="Watch HHBD’s Aviator rise — tempo, intention, and smart exits playing out in motion"
        >
          <img
            src={av1}
            alt="A smiling Bengal tiger — HHBD’s mascot — in vintage aviator gear with goggles and scarf, giving a confident thumbs-up."
            title="HHBD Aviator — Bangladesh’s favorite crash experience, now in your hands"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-aviatorlux">
      <div className="zHHBD-aviatorlux__cloud zHHBD-aviatorlux__cloud--1"></div>
      <div className="zHHBD-aviatorlux__cloud zHHBD-aviatorlux__cloud--2"></div>
      <div className="zHHBD-aviatorlux__cloud zHHBD-aviatorlux__cloud--3"></div>
      <div className="zHHBD-aviatorlux__stars">
        <span className="star star--1"></span>
        <span className="star star--2"></span>
        <span className="star star--3"></span>
        <span className="star star--4"></span>
        <span className="star star--5"></span>
      </div>

      <div className="zHHBD-aviatorlux__wrapper">
        <figure className="zHHBD-aviatorlux__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="Real HHBD Aviator lobbies — multiplayer tempo, sharp ascents, readable patterns, and practical HUD overlays"
          >
            <img
              src={av2}
              alt="A stylish young woman, fully focused and energized, playing Aviator on a laptop in a bright, modern space."
              title="HHBD Aviator — Gameplay rhythm and hands-on strategy for the crash format"
              className="zHHBD-aviatorlux__img"
            />
          </a>
        </figure>

        <div className="zHHBD-aviatorlux__content">
          <h2 className="zHHBD-aviatorlux__title">
            What Makes Aviator Special — and Why Everyone’s Talking About It
          </h2>
          <p className="zHHBD-aviatorlux__text">
            Aviator fuses social energy with ultra-clear rules. The loop is refreshingly simple:
            a plane takes off, the live multiplier climbs with altitude, and your mission is to cash out
            before the aircraft darts away. Exit in time and you secure your stake multiplied by the on-screen
            coefficient. Wait a heartbeat too long and the round ends instantly — your bet is gone.
          </p>
          <p className="zHHBD-aviatorlux__text">
            Across Bangladesh, the draw is its clarity, speed, and pure adrenaline. Rounds finish in seconds,
            delivering a constant stream of high-tempo action. The shared lobby intensifies the rush — track other players’
            wagers and wins live, chat alongside the crowd, and enjoy a truly community-driven atmosphere.
          </p>
          <p className="zHHBD-aviatorlux__text">
            Most importantly, Aviator runs on Provably Fair technology. This cryptographic system guarantees transparent
            outcomes that can’t be altered by the <Link to="casino" className="zHHBD-aviatorlux__link">casino</Link>.
            Verify every single round yourself — play with full confidence and real peace of mind.
          </p>
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-aviatorlux__btn"
            title="Open an HHBD Aviator lobby now and map a clean, confident flight path into the stratosphere"
          >
            Test Aviator in Free Demo Mode
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-aviatorsteps">
      <div className="zHHBD-aviatorsteps__runway"></div>
      <div className="zHHBD-aviatorsteps__runway zHHBD-aviatorsteps__runway--2"></div>
      <div className="zHHBD-aviatorsteps__golden">
        <span className="dot dot--1"></span>
        <span className="dot dot--2"></span>
        <span className="dot dot--3"></span>
        <span className="dot dot--4"></span>
        <span className="dot dot--5"></span>
      </div>

      <div className="zHHBD-aviatorsteps__container">
        <figure className="zHHBD-aviatorsteps__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="Aviator on HHBD — clean lanes, risk rails, and readable profit vectors in a single focused dashboard"
          >
            <img
              src={av3}
              alt="A tactical flight chart for consistent HHBD Aviator returns — routes, tempos, and risk checks mapped with crisp clarity."
              title="HHBD Aviator atlas — chart smarter routes for steady, reliable growth with transparent guidance"
              className="zHHBD-aviatorsteps__img"
            />
          </a>
        </figure>

        <div className="zHHBD-aviatorsteps__content">
          <h2 className="zHHBD-aviatorsteps__title">
            How to Play Aviator on HHBD — A Simple, Actionable Guide
          </h2>
          <ol className="zHHBD-aviatorsteps__steps">
            <li>
              Getting started is straightforward. Choose your wager first. You can arm one — or even two —
              simultaneous bets each round to explore different tactics. Enter your amount in the bet
              panel below and press ‘Bet’ to lock your positions for takeoff.
            </li>
            <li>
              As the round begins, the plane lifts off and the multiplier starts at 1×, then climbs upward.
              Follow the ascent as the number grows — with every passing second, your potential payout increases.
            </li>
            <li>
              The crucial move is the cashout. Click ‘Cash Out’ anytime while the aircraft remains visible.
              Your win is fixed immediately at the current multiplier. Balance patience with control — aim for a strong figure
              without letting greed keep you in the air for too long!
            </li>
          </ol>

          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-aviatorsteps__btn"
            title="Jump into HHBD Aviator now — ride confident multipliers with focus, control, and conviction"
          >
            Play the Free Aviator Demo
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-aviatorwhy">
      <div className="zHHBD-aviatorwhy__bg"></div>
      <div className="zHHBD-aviatorwhy__flare zHHBD-aviatorwhy__flare--1"></div>
      <div className="zHHBD-aviatorwhy__flare zHHBD-aviatorwhy__flare--2"></div>

      <div className="zHHBD-aviatorwhy__wrapper">
        <figure className="zHHBD-aviatorwhy__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="Essential HHBD Aviator utilities and pro frameworks for confident, consistent, evidence-led decision making"
          >
            <img
              src={av4}
              alt="Core Aviator systems with advanced controls — stable command, clear data, and cool-headed visibility inside HHBD."
              title="HHBD Aviator — Professional tools and dependable features for clarity, consistency, and measured control"
              className="zHHBD-aviatorwhy__img"
            />
          </a>
        </figure>

        <h2 className="zHHBD-aviatorwhy__title">
          Pro Pointers & HHBD’s Standout Aviator Features
        </h2>

        <div className="zHHBD-aviatorwhy__cards">
          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-rocket"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                Lean on the ‘Auto’ tools for smoother, more disciplined sessions. ‘Auto Bet’ re-arms your wager every round,
                while ‘Auto Cashout’ exits the moment your preset multiplier is reached — a simple way to enforce your plan.
              </span>
            </div>
          </div>

          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-comments"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                The interface displays rolling statistics — recent outcomes, daily top wins, and live player activity.
                Treat these boards as pacing context only; each round is independent and results remain entirely random.
              </span>
            </div>
          </div>

          {/* NEW card 3 */}
          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-layer-group"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                A popular tactic is running two parallel bets. Set one Auto Cashout at a modest, safer mark (e.g., 1.5×)
                to cover your stake, and let the second ride toward a higher target — a controlled swing at standout returns.
              </span>
            </div>
          </div>

          {/* NEW card 4 */}
          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-shield-heart"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                Above all, play responsibly. Decide your session budget and stick to it. Aviator is fast and chance-driven —
                don’t chase losses. Keep it fun, stay measured, and make every ascent an intentional one.
              </span>
            </div>
          </div>
        </div>

        <p className="zHHBD-aviatorwhy__intro">
          {/* структура сохранена */}
        </p>

        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-aviatorwhy__btn"
          title="Play HHBD Aviator now with powerful utilities and sharp, expert-grade guidance right at your fingertips"
        >
          Launch Your Flight Today
        </a>
      </div>
    </section>
  </>

      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
  <>
    <section className="zHHBD-aviatorhero">
      {/* পটভূমি */}
      <div className="zHHBD-aviatorhero__bg">
        <div className="zHHBD-aviatorhero__overlay"></div>
        <div className="zHHBD-aviatorhero__flare zHHBD-aviatorhero__flare--1"></div>
        <div className="zHHBD-aviatorhero__flare zHHBD-aviatorhero__flare--2"></div>
      </div>

      {/* অ্যানিমেটেড প্লেন */}
      <div className="zHHBD-aviatorhero__plane"></div>

      <div className="zHHBD-aviatorhero__container">
        <div className="zHHBD-aviatorhero__content">
          <h1 className="zHHBD-aviatorhero__title">
           HHBD Aviator – দুর্ঘটনার আগে উড়ে যান এবং টাকা আউট করুন
          </h1>
          <p className="zHHBD-aviatorhero__desc">
            Aviator-এর গতি অনুভব করুন — বাংলাদেশ জুড়ে জনপ্রিয় এই অতিদ্রুত ক্র্যাশ ফরম্যাট।
            আপনার স্টেক নির্ধারণ করুন, সৌভাগ্যের বিমানকে ঊর্ধ্বমুখী হতে দেখুন, আর প্রতি সেকেন্ডে মাল্টিপ্লায়ার বাড়ার সাথে সাথে মুনাফা সংগ্রহ করুন।
            পুরো কৌশলটাই হচ্ছে সময়মতো বেরোনো — বিমানটি স্ক্রিন থেকে মিলিয়ে যাওয়ার অনেক আগেই ক্যাশ-আউট করে জয় নিশ্চিত করুন!
          </p>
          <div className="zHHBD-aviatorhero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-aviatorhero__btn zHHBD-aviatorhero__btn--main"
              title="এখনই HHBD-তে Aviator শুরু করুন — আগেই এক্সিট লক্ষ্য ঠিক করে শৃঙ্খলাবদ্ধ সেশনে স্থির, নির্ভরযোগ্য ক্যাশআউট তৈরি করুন"
            >
              এখনই আপনার ফ্লাইট শুরু করুন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-aviatorhero__btn zHHBD-aviatorhero__btn--ghost"
              title="মোবাইলে মসৃণ, বিঘ্নহীন পারফরম্যান্সে যেকোনো জায়গায় Aviator খেলতে HHBD অ্যাপ ইনস্টল করুন"
            >
              ফ্রি অ্যাপ ডাউনলোড করুন
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD-এর Aviator-এ আরোহনের তাল, উদ্দেশ্য আর স্মার্ট এক্সিট — সবকিছু লাইভ অনুভব করুন"
        >
          <img
            src={av1}
            alt="হাসিখুশি একটি বেঙ্গল টাইগার — HHBD-এর মাসকট — ভিনটেজ এভিয়েটর গগলস ও স্কার্ফ পরা, আত্মবিশ্বাসী থাম্বস-আপ দিচ্ছে।"
            title="HHBD Aviator — বাংলাদেশের প্রিয় ক্র্যাশ অভিজ্ঞতা, এখন আপনার হাতে"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-aviatorlux">
      <div className="zHHBD-aviatorlux__cloud zHHBD-aviatorlux__cloud--1"></div>
      <div className="zHHBD-aviatorlux__cloud zHHBD-aviatorlux__cloud--2"></div>
      <div className="zHHBD-aviatorlux__cloud zHHBD-aviatorlux__cloud--3"></div>
      <div className="zHHBD-aviatorlux__stars">
        <span className="star star--1"></span>
        <span className="star star--2"></span>
        <span className="star star--3"></span>
        <span className="star star--4"></span>
        <span className="star star--5"></span>
      </div>

      <div className="zHHBD-aviatorlux__wrapper">
        <figure className="zHHBD-aviatorlux__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="বাস্তব HHBD Aviator লবি — মাল্টিপ্লেয়ার গতি, তীক্ষ্ণ আরোহন, পড়নযোগ্য প্যাটার্ন আর প্র্যাকটিক্যাল HUD ওভারলে"
          >
            <img
              src={av2}
              alt="আধুনিক উজ্জ্বল ঘরে ল্যাপটপে মনোযোগীভাবে Aviator খেলছেন এক স্টাইলিশ তরুণী — উদ্দীপ্ত ও ফোকাসড।"
              title="HHBD Aviator — ক্র্যাশ ফরম্যাটে গেমপ্লের রিদম ও ব্যবহারিক কৌশল"
              className="zHHBD-aviatorlux__img"
            />
          </a>
        </figure>

        <div className="zHHBD-aviatorlux__content">
          <h2 className="zHHBD-aviatorlux__title">
            Aviator কেন আলাদা — আর কেন সবাই এ নিয়ে আলোচনা করছে
          </h2>
          <p className="zHHBD-aviatorlux__text">
            Aviator সামাজিক মজা আর একদম স্বচ্ছ নিয়মকে একত্র করে। লুপটা অত্যন্ত সহজ:
            বিমান উড়ে, উচ্চতার সাথে লাইভ মাল্টিপ্লায়ার বাড়ে, আর আপনার কাজ — বিমান মিলিয়ে যাওয়ার আগে ক্যাশ-আউট করা।
            সময়মতো বেরোতে পারলেই স্ক্রিনে দেখানো গুণকের ভিত্তিতে স্টেক বহুগুণে ফিরে পাবেন। এক সেকেন্ড দেরি করলেই রাউন্ড সাথে সাথে শেষ — বেট হারিয়ে যাবে।
          </p>
          <p className="zHHBD-aviatorlux__text">
            বাংলাদেশে এর আকর্ষণ হচ্ছে স্বচ্ছতা, গতি, আর খাঁটি রোমাঞ্চ। প্রতিটি রাউন্ড কয়েক সেকেন্ডেই শেষ,
            ফলে উচ্চ-টেম্পোর ধারাবাহিক অ্যাকশন পাওয়া যায়। শেয়ার্ড লবি উত্তেজনা বাড়ায় — অন্যদের বেট ও জয় লাইভ দেখুন,
            সাথে চ্যাট করুন, আর সত্যিকারের কমিউনিটি-ড্রিভেন পরিবেশ উপভোগ করুন।
          </p>
          <p className="zHHBD-aviatorlux__text">
            সবচেয়ে গুরুত্বপূর্ণ, Aviator চলে Provably Fair প্রযুক্তিতে। এই ক্রিপ্টোগ্রাফিক সিস্টেম ফলাফলকে স্বচ্ছ রাখে
            এবং কোনোভাবেই <Link to={getLangPath("/casino", lang)} className="zHHBD-aviatorlux__link">ক্যাসিনো</Link> দ্বারা পরিবর্তন করা যায় না।
            প্রতিটি রাউন্ড নিজে যাচাই করতে পারবেন — সম্পূর্ণ আত্মবিশ্বাস ও নিশ্চিন্ত মনে খেলুন।
          </p>
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-aviatorlux__btn"
            title="এখনই HHBD-তে Aviator লবি খুলুন এবং আত্মবিশ্বাসী, পরিষ্কার ফ্লাইট-পাথ চার্ট করুন"
          >
            ফ্রি ডেমো মোডে Aviator চেষ্টা করুন
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-aviatorsteps">
      <div className="zHHBD-aviatorsteps__runway"></div>
      <div className="zHHBD-aviatorsteps__runway zHHBD-aviatorsteps__runway--2"></div>
      <div className="zHHBD-aviatorsteps__golden">
        <span className="dot dot--1"></span>
        <span className="dot dot--2"></span>
        <span className="dot dot--3"></span>
        <span className="dot dot--4"></span>
        <span className="dot dot--5"></span>
      </div>

      <div className="zHHBD-aviatorsteps__container">
        <figure className="zHHBD-aviatorsteps__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD-তে Aviator — এক ড্যাশবোর্ডেই পরিষ্কার রুট, রিস্ক রেল আর পড়নযোগ্য প্রফিট ভেক্টর"
          >
            <img
              src={av3}
              alt="স্থিতিশীল রিটার্নের জন্য HHBD Aviator-এর ট্যাকটিকাল ফ্লাইট চার্ট — রুট, টেম্পো ও রিস্ক-চেক স্পষ্টভাবে ম্যাপড।"
              title="HHBD Aviator অ্যাটলাস — স্বচ্ছ নির্দেশনায় স্মার্টার রুট চার্ট করে শৃঙ্খলাবদ্ধ, নির্ভরযোগ্য গ্রোথ"
              className="zHHBD-aviatorsteps__img"
            />
          </a>
        </figure>

        <div className="zHHBD-aviatorsteps__content">
          <h2 className="zHHBD-aviatorsteps__title">
            HHBD-তে Aviator কীভাবে খেলবেন — সহজ, কার্যকর একটি গাইড
          </h2>
          <ol className="zHHBD-aviatorsteps__steps">
            <li>
              শুরুটা একদম সরল। প্রথমে আপনার ওয়েজার ঠিক করুন। চাইলে প্রতি রাউন্ডে একসাথে এক বা দুইটি
              বেট আর্ম করতে পারেন — আলাদা কৌশল পরীক্ষা করতে সুবিধা হবে। নিচের বেট প্যানেলে এমাউন্ট লিখুন,
              তারপর ‘Bet’ টিপে টেক-অফের জন্য আপনার পজিশন লক করুন।
            </li>
            <li>
              রাউন্ড শুরু হলে বিমান উড়বে এবং মাল্টিপ্লায়ার 1× থেকে বাড়তে থাকবে।
              সংখ্যা বাড়ার সাথে সাথে আপনার সম্ভাব্য পেআউটও বেড়ে চলবে — প্রতি সেকেন্ডেই সুযোগ বড় হচ্ছে।
            </li>
            <li>
              সিদ্ধান্তমূলক পদক্ষেপটি হলো ক্যাশ-আউট। বিমানটি দৃশ্যমান থাকা অবস্থায় যেকোনো সময় ‘Cash Out’ ক্লিক করুন।
              বর্তমান মাল্টিপ্লায়ারেই জয় নির্ধারিত হবে। ধৈর্য ও নিয়ন্ত্রণের ভারসাম্য রাখুন — ভাল রিটার্ন লক্ষ্য করুন,
              কিন্তু লোভে বেশি সময় আকাশে ভেসে থাকবেন না!
            </li>
          </ol>

          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-aviatorsteps__btn"
            title="এখনই HHBD-তে Aviator খেলুন — ফোকাস, কন্ট্রোল ও আত্মবিশ্বাসে শক্তিশালী মাল্টিপ্লায়ার রাইড করুন"
          >
            ফ্রি Aviator ডেমো খেলুন
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-aviatorwhy">
      <div className="zHHBD-aviatorwhy__bg"></div>
      <div className="zHHBD-aviatorwhy__flare zHHBD-aviatorwhy__flare--1"></div>
      <div className="zHHBD-aviatorwhy__flare zHHBD-aviatorwhy__flare--2"></div>

      <div className="zHHBD-aviatorwhy__wrapper">
        <figure className="zHHBD-aviatorwhy__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD-তে Aviator-এর প্রয়োজনীয় টুলস ও প্রো ফ্রেমওয়ার্ক — আত্মবিশ্বাসী, ধারাবাহিক, প্রমাণ-ভিত্তিক সিদ্ধান্তের জন্য"
          >
            <img
              src={av4}
              alt="এডভান্সড কন্ট্রোলসহ কোর Aviator সিস্টেম — স্থির কমান্ড, স্বচ্ছ ডেটা, আর কুল-হেডেড ভিজিবিলিটি HHBD-এর ভিতরে।"
              title="HHBD Aviator — স্বচ্ছতা, ধারাবাহিকতা ও মেপে খেলার জন্য প্রফেশনাল টুলস ও নির্ভরযোগ্য ফিচার"
              className="zHHBD-aviatorwhy__img"
            />
          </a>
        </figure>

        <h2 className="zHHBD-aviatorwhy__title">
          প্রো টিপস ও HHBD-এর সেরা Aviator ফিচারসমূহ
        </h2>

        <div className="zHHBD-aviatorwhy__cards">
          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-rocket"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                আরও মসৃণ ও শৃঙ্খলাবদ্ধ সেশনের জন্য ‘Auto’ টুল ব্যবহার করুন। ‘Auto Bet’ প্রতিটি রাউন্ডে স্বয়ংক্রিয়ভাবে বেট আর্ম করে,
                আর ‘Auto Cashout’ আপনার প্রিসেট মাল্টিপ্লায়ারে পৌঁছাতেই সঙ্গে সঙ্গে এক্সিট দেয় — পরিকল্পনা মানতে এটি সহজ উপায়।
              </span>
            </div>
          </div>

          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-comments"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                ইন্টারফেসে রোলিং স্ট্যাটস দেখা যায় — সাম্প্রতিক ফলাফল, দিনের সেরা জয়, লাইভ প্লেয়ার অ্যাক্টিভিটি।
                এগুলোকে কেবল গতি বোঝার প্রেক্ষাপট হিসেবে দেখুন; প্রতিটি রাউন্ড স্বাধীন এবং ফলাফল সম্পূর্ণ র‍্যান্ডমই থাকে।
              </span>
            </div>
          </div>

          {/* NEW card 3 */}
          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-layer-group"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                জনপ্রিয় এক কৌশল হলো সমান্তরালে দুইটি বেট চালানো। একটি Auto Cashout তুলনামূলক নিরাপদ স্তরে (যেমন 1.5×) সেট করে
                স্টেক কভার করুন, আর দ্বিতীয়টি বেশি টার্গেটের দিকে ছেড়ে দিন — নিয়ন্ত্রিতভাবে বড় রিটার্নের সম্ভাবনা বাড়াতে।
              </span>
            </div>
          </div>

          {/* NEW card 4 */}
          <div className="zHHBD-aviatorwhy__card">
            <div className="zHHBD-aviatorwhy__icon">
              <i className="fa-solid fa-shield-heart"></i>
            </div>
            <div className="zHHBD-aviatorwhy__info">
              <span className="zHHBD-aviatorwhy__text">
                সবচেয়ে আগে দায়িত্বশীলভাবে খেলুন। সেশন বাজেট ঠিক করুন এবং সেটাই মেনে চলুন। Aviator দ্রুতগতি ও ভাগ্যনির্ভর —
                ক্ষতি পুষিয়ে নেওয়ার তাড়া করবেন না। খেলাটা উপভোগ্য রাখুন, মেপে এগোন, আর প্রতিটি আরোহন হোক সুচিন্তিত।
              </span>
            </div>
          </div>
        </div>

        <p className="zHHBD-aviatorwhy__intro">
          {/* গঠন অপরিবর্তিত রাখা হয়েছে */}
        </p>

        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-aviatorwhy__btn"
          title="শক্তিশালী টুলস ও তীক্ষ্ণ, বিশেষজ্ঞ-ধাঁচের গাইডেন্সসহ এখনই HHBD-তে Aviator খেলুন"
        >
          আজই আপনার ফ্লাইট শুরু করুন
        </a>
      </div>
    </section>
  </>



      )}
    </>
  );
};

export default Aviator;
